import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=59977da2"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports